import { contact } from "../data/contact";
import { MessageCircle } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export default function WhatsAppFloat() {
  const { t } = useLanguage();
  return (
    <a
      href={contact.whatsappUrl}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-40 group"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp"
    >
      <span className="absolute inset-0 rounded-full bg-emerald-500/30 animate-ping" />
      <span className="relative flex items-center gap-2 rounded-full bg-emerald-500 text-white px-5 py-3 shadow-2xl shadow-emerald-500/30 hover:bg-emerald-400 transition-colors">
        <MessageCircle size={18} />
        <span className="hidden sm:inline text-sm font-semibold">{t.nav.whatsapp}</span>
      </span>
    </a>
  );
}
